import { useStore } from 'zustand';

import { authStore, type AuthState } from './auth-store';

export function useAuthStore<T>(selector: (state: AuthState) => T): T {
  return useStore(authStore, selector);
}
